import { BitMap, Color } from "./bitmap";
import { Bin } from "./types";
import { useEffect } from "react";
import { count } from "console";

export function bitMap2Image(bitMap: BitMap<Color>, size: number = 20): HTMLCanvasElement {
  const canvas = document.createElement('canvas');
  const { width, height } = bitMap;
  canvas.width = width * size;
  canvas.height = height * size;
  const ctx = canvas.getContext('2d');
  for (let x = 0; x < width; x++)
    for (let y = 0; y < height; y++) {
      const c = bitMap.get(x, y);
      const { r, g, b, a } = c;
      ctx.fillStyle = `rgba(${r},${g},${b},${a})`;
      ctx.fillRect(x * size, y * size, size, size);
    }
  return canvas;
}

export function useBitMap2Image(ref: React.MutableRefObject<HTMLCanvasElement>, bitMap: BitMap<Color>, size: number) {
  useEffect(() => {
    if (ref.current) {
      const canvas = ref.current;
      const { width, height } = bitMap;
      canvas.width = width * size;
      canvas.height = height * size;
      const ctx = canvas.getContext('2d');
      for (let x = 0; x < width; x++)
        for (let y = 0; y < height; y++) {
          const c = bitMap.get(x, y);
          const { r, g, b, a } = c;
          ctx.fillStyle = `rgba(${r},${g},${b},${a})`;
          ctx.fillRect(x * size, y * size, size, size);
        }
      // const src = ctx.getImageData(0,0,canvas.width,canvas.height);
      // console.log('src',src)
      // const data = window.bex.bild.effect.invert(src)
      // console.log('data',data);
      // ctx.putImageData(data,0,0)
    }
  }, [])
}

export function bitMap2Bin(bitMap: BitMap<Color>): ImageData {
  const { width, height } = bitMap;
  const data = new Uint8ClampedArray(width * height * 4);
  for (let x = 0; x < width; x++)
    for (let y = 0; y < height; y++) {
      const { r, g, b, a } = bitMap.get(x, y);
      data.set([r, g, b, Math.floor(255 * a)], (x * width + y) * 4)
    }
  return new ImageData(data, width, height);
}

export function imageData2Base64(imageData: ImageData): Bin {
  return {
    width: imageData.width,
    height: imageData.height,
    data: new Buffer(imageData.data.buffer).toString('base64')
  }
}

export function base642ImageData(data: Bin): ImageData {
  return new ImageData(new Uint8ClampedArray(new Buffer(data.data, 'base64')), data.width, data.height)
}

export function imageData2BitMap(data: ImageData): BitMap<Color> {
  const { width, height } = data;
  const m = new BitMap<Color>(width, height, Color.none);
  for (let x = 0; x < width; x++)
    for (let y = 0; y < height; y++) {
      const [r, g, b, a] = Array.from(data.data.slice((x * width + y) * 4, (x * width + y + 1) * 4));
      m.put(x, y, new Color(r, g, b, a / 255));
    }
  return m;
}

/**
 * bitMap 转 base64
 * @param bitMap 
 */
export const bitMap2Base64 = (bitMap: BitMap<Color>) => imageData2Base64(bitMap2Bin(bitMap));

/**
 * base64 转 bitMap
 * @param bin 
 */
export const base642BitMap = (bin: Bin) => imageData2BitMap(base642ImageData(bin));


export function bitMap2ImageData(bitMap: BitMap<Color>, size: number = 20): ImageData {
  return bitMap2Image(bitMap, size).getContext('2d').getImageData(0, 0, bitMap.width * size, bitMap.height * size)
}